import { useState, useEffect } from "react";
import { Stepper } from "react-form-stepper";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";

// get sequence from query API
import { useSequence } from "./../api";

// contexts
import { useSampleContext } from "./../contexts";
// import { ReachbackProvider } from "../contexts/ReachbackContext";

// components
import Footer from "./../components/Footer";
import Navbar from "../components/SpectraNavbar";

// pages for Wizard
import WizardDeviceSelection from "../components/WizardPages/WizardDeviceSelection";
import WizardCalibrate from "../components/WizardPages/WizardCalibrate";
import WizardSampleInfo from "../components/WizardPages/WizardSampleInfo";
import WizardBulk from "./../components/WizardPages/Wasatch/WizardBulk";
import WasatchWizardTrace from "../components/WizardPages/Wasatch/WasatchWizardTrace";
import WasatchWizardSummary from "../components/WizardPages/Wasatch/WasatchWizardSummary";

import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

const NewSample = () => {
  // useSequence api fetches data from backend with library name
  const { data: bulk, isFetching: bulkFetching } = useSequence("Narcotics");
  const { data: trace, isFetching: traceFetching } = useSequence("Amplifi");

  const { sample, initBulk, initTrace } = useSampleContext();

  // step tracker, this state is used to show corresponding wizard page
  const [step, setStep] = useState(0);
  const [stepAction, setStepAction] = useState("");

  //booleans for if calibration is needed and to show the successfull calibration toast
  const [isCalibrate, setIsCalibrate] = useState(false);
  const [showToast, setShowToast] = useState(false);

  //
  const [submitStatus, setSubmitStatus] = useState(true);

  // List of wizard pages. The order of the list is the order the pages will be displayed.
  const wizardPagesList = [
    "WizardDeviceSelection",
    "WizardSampleInfo",
    "WizardBulk",
    "WasatchWizardTrace",
    "WasatchWizardSummary",
  ];

  // convert the list of wizard pages to an object with numerical values
  const generateFlow = () => {
    return {
      ...wizardPagesList.reduce((a, v, index) => ({ ...a, [v]: index }), {}),
      WizardCalibrate: "calibrate",
    };
  };

  // Genereate Wizard Pages
  const wizardPages = generateFlow();
  console.log(wizardPages);

  // Labels for stepper, currently set to no labels
  let wizardSteps = [];
  for (let i = 0; i < Object.keys(wizardPages).length - 1; i++) {
    wizardSteps.push({ label: "" });
  }

  // update bulk sequence state on query update
  useEffect(() => {
    if (!bulkFetching) {
      setData(bulk.sequences, "bulk-burst");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkFetching, bulk]);

  //update trace seuqecs on query update
  useEffect(() => {
    if (!traceFetching) {
      setData(trace.sequences, "trace-burst");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [traceFetching, trace]);

  // set data function to update the state of either bulk or trace sequences
  const setData = (sequence, type) => {
    if (type === "bulk-burst") {
      initBulk(sequence);
    }
    if (type === "trace-burst") {
      initTrace(sequence);
    }
  };

  // show sample on update in console for debug purposes
  useEffect(() => {
    console.log(sample);
  }, [sample]);

  // function to update the step
  // this will be passed into each Wizard Component
  // and will appropriately udpate the current step
  const changeStep = (value) => {
    setStepAction(value);
    console.log("step:", step, value);

    if (value === "calibrate") {
      setIsCalibrate(true);
    }
    if (value === "return") {
      setStep(wizardPages.WizardDeviceSelection);
    }
    if (value === "continue") {
      setStep(wizardPages.WizardSampleInfo);
    }
    if (value === "forward" && step < 10) {
      setStep(step + 1);
    }
    if (value === "back" && step > 0) {
      setStep(step - 1);
    }
    if (value === "reset") {
      resetForm();
    }
  };

  function redirect() {}

  const resetForm = () => {
    setStep(0);
  };

  return (
    <div className='flex-container'>
      <Navbar authenticated={false} />
      <div aria-live='polite' aria-atomic='true' className='position-relative'>
        <ToastContainer
          position='top-end'
          style={{ zIndex: 1, marginTop: "79px" }}
        >
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={5000}
            autohide
            bg={"success"}
            animation={true}
            className='d-inline-block'
          >
            <Toast.Header style={{ justifyContent: "space-between" }}>
              <strong>Calibration Successful!</strong>
            </Toast.Header>
            <Toast.Body style={{ color: "var(--bs-light)" }}>
              Device operating correctly and ready to scan.
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      <div
        className='flex-body w-100 mx-auto py-3 px-sm-3 px-lg-5'
        style={{ marginTop: "79px" }}
      >
        {step !== "" && (
          <div className=''>
            <Stepper
              steps={wizardSteps}
              activeStep={step}
              // connectorStyleConfig={{stepSize:'3em'}} doesn't seem to be working atm
              styleConfig={{
                size: "1.5em",
                activeBgColor: "#1CA4EE",
                completedBgColor: "#8ED2F7",
                shape: "circle",
                color: "#fff",
              }}
              style={{ padding: "5px" }}
            />
          </div>
        )}
        <div className='mt-3 justify-content-center w-100 h-100 flex-grow-1 full-height'>
          <WizardDeviceSelection
            step={step}
            steps={wizardSteps}
            isCalibrate={isCalibrate}
            changeStep={changeStep}
            pageID={wizardPages.WizardDeviceSelection}
          />
          <WizardCalibrate
            step={step}
            isCalibrate={isCalibrate}
            setIsCalibrate={setIsCalibrate}
            steps={wizardSteps}
            changeStep={changeStep}
            pageID={wizardPages.WizardCalibrate}
            setShowToast={setShowToast}
          />
          <WizardSampleInfo
            step={step}
            steps={wizardSteps}
            changeStep={changeStep}
            pageID={wizardPages.WizardSampleInfo}
          />
          <WizardBulk
            step={step}
            steps={wizardSteps}
            changeStep={changeStep}
            pageID={wizardPages.WizardBulk}
          />
          <WasatchWizardTrace
            step={step}
            steps={wizardSteps}
            stepAction={stepAction}
            changeStep={changeStep}
            pageID={wizardPages.WasatchWizardTrace}
          />
          <WasatchWizardSummary
            step={step}
            steps={wizardSteps}
            pageID={wizardPages.WasatchWizardSummary}
            changeStep={changeStep}
            bulk={bulk} // Pass the 'bulk' data as a prop
            trace={trace}
          />
        </div>
        {!submitStatus && (
          <div className='alert alert-danger' role='alert'>
            Something went wrong, please try again!
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default NewSample;
